import ComponentsOfChangeTableV3 from './ComponentsOfChangeTableV3'

const componentsOfChangeV3Module = {
  ComponentsOfChangeTableV3
}

export default componentsOfChangeV3Module
